import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment-timezone'
import Chat from './Chat'
import { secondsToBriefDhms } from '../redux/FeedbackRedux'

class Chats extends React.Component {

	render () {
		const feedback = this.props.feedback;
		const chats = feedback.chats;
		const feedbackerId = feedback.user_id;

		const automationType = feedback.aiSettingsAutomationType;
		const isAutomated = automationType === 'semi' || automationType === 'full';

		const chat_messages = chats.map((value, index) => {
			const isOutgoing = value.sender_id !== feedbackerId;
			let aiLabel = '';
			let sentIn = '';
			let isAutoResponse = value.auto_response || value.auto_review || value.message_source === 'ai';

			if (isOutgoing) {
				if (value.message_source === 'human') {
					const chatPercentAltered = value.percent_altered;
					if (chatPercentAltered !== null && chatPercentAltered !== undefined && chatPercentAltered < 2) {
						aiLabel = 'AI Suggested, Unedited';
					} else if (chatPercentAltered !== null && chatPercentAltered !== undefined && chatPercentAltered <= 75) {
						aiLabel = 'AI Suggested, Edited (used ' + (100 - chatPercentAltered) + '% of Suggested)';
					} else {
						aiLabel = 'User Generated, No AI';
					}
				} else if (value.message_source === 'ai') {
					const firstName = value.sender ? (value.sender.display_title ? value.sender.title : (value.sender.firstname ?? '')) : '';
					const lastInitial = value.sender?.lastname ? value.sender.lastname.substring(0, 1) : '';
					const senderName = (firstName + (lastInitial ? ' ' + lastInitial : '')).trim();
					aiLabel = 'AI Auto-Response' + (senderName ? ' as ' + senderName : '');
				} else if (value.message_source === 'system') {
					aiLabel = '';
				} else {
					aiLabel = 'User Generated, No AI';
				}
			}

			// Calculate "Sent in" time for all messages
			let previousTimestamp = null;
			for (let i = index - 1; i >= 0; i--) {
				if (chats[i].created_at) {
					previousTimestamp = chats[i].created_at;
					break;
				}
			}
			if (!previousTimestamp) {
				previousTimestamp = feedback.timest || feedback.created_at;
			}

			if (previousTimestamp && value.created_at) {
				const diffSeconds = moment(value.created_at).diff(moment(previousTimestamp), 'seconds');
				if (diffSeconds >= 0) {
					sentIn = secondsToBriefDhms(diffSeconds, true);
				}
			}

			return (
				<Chat
					key={index}
					hidename={this.props.hidename}
					chat={value}
					id={value.id}
					red_alerts_list={this.props.red_alerts_list}
					aiLabel={aiLabel}
					sentIn={sentIn}
					isAutoResponse={isAutoResponse}
				/>
			);
		});

		return (
		<div className="chat_widget_body">
			{chat_messages}
		</div>
		);
	}
}

function mapStateToProps(state) {
	return { feedback:state.feedback_detail, red_alerts:state.red_alerts??null, red_alerts_list:state.red_alerts_list??null }
}

export default connect(mapStateToProps)(Chats)
